import { Box } from "@mui/material"
import React from "react"
import { EmployeeSelector, EmptyState, LoadingState } from "./DashboardStates"
import { MobileExaminationView } from "./MobileExaminationView"
import { useDashboard } from "./useDashboard"

const DashboardMobile = React.memo(() => {
  const {
    projects,
    employees,
    leads,
    customers,
    user,
    selectedEmployeeId,
    // selectedProjectId,
    isLoading,
    handleEmployeeChange,
    // handleProjectSelect,
    hasProjects,
  } = useDashboard({ includeMobileState: true })

  // Loading state
  if (isLoading) {
    return <LoadingState />
  }

  // Empty state
  if (!hasProjects) {
    return (
      <EmptyState
        selectedEmployeeId={selectedEmployeeId}
        employees={employees}
        onEmployeeChange={handleEmployeeChange}
        currentUserId={user.id}
      />
    )
  }

  return (
    <Box component="main" role="main">
      {/* Filter Controls */}
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 2,
        }}
      >
        <EmployeeSelector
          employees={employees}
          selectedEmployeeId={selectedEmployeeId}
          onEmployeeChange={handleEmployeeChange}
          currentUserId={user.id}
        />
      </Box>

      {/* Mobile Content */}

      <MobileExaminationView
        projects={projects}
        selectedEmployeeId={selectedEmployeeId}
        leads={leads}
        customers={customers}
      />
    </Box>
  )
})

export default DashboardMobile
